export class AssessmentScaleRange{
    fromMark: number;
    toMark: number;
    scaleValue: number;
}